export const PORTRAIT = "https://customer-assets-jt897jd0.emergentagent.net/job_election-portal-38/artifacts/ujsq1wuk_copy_DA36EA30-4AF3-46B2-A108-E117BBD59491.webp";
export const CITY = "https://images.unsplash.com/photo-1783308529732-42e743dc1ce8";
export const VOLUNTEERS = "https://images.pexels.com/photos/6646918/pexels-photo-6646918.jpeg";
export const CROWD = "https://images.pexels.com/photos/3892902/pexels-photo-3892902.jpeg";
